import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    margin: '2rem 1.6rem 0',

    paddingBottom: '4rem',
    [$theme.mediaQuery.large]: {
        width: '60rem',
        margin: '4rem auto 0'
    }
}))

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingMedium,
    fontWeight: 700,
    margin: 0,
    color: '#000'
}))

export const ContentContainer = styled('div', ({ $theme }) => ({
    marginTop: '0.8rem'
}))

export const Answer = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    padding: '1.6rem',
    whiteSpace: 'pre-line',
    [$theme.mediaQuery.large]: {
        margin: 0
    }
}))

export const Content = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
}))

export const Question = styled<'h4', { $selected?: boolean }>('h4', ({ $theme, $selected = false }) => ({
    ...$theme.typography.ParagraphMedium,
    fontWeight: 600,
    marginTop: 0,
    color: $selected ? $theme.colors.primary : '#1F1F1F',
    marginBottom: 0,
    backgroundColor: '#F6F6F6',
    borderRadius: '24px',
    padding: '1.6rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '0.8rem',
    cursor: 'pointer'
}))

export const SectionsContainer = styled('div', ({ $theme }) => ({
    marginTop: '2rem',
    [$theme.mediaQuery.large]: {
        flex: 1
    }
}))

export const NoResultsFound = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    padding: '1.6rem 0'
}))
